import { Link, useSearch } from 'wouter';
import { SUPPORT_EMAIL } from '../../lib/support';

export function SupportPage() {
  const search = useSearch();
  const params = new URLSearchParams(search);
  const hasBugContext = params.has('source_path') || params.has('billing_test_mode');
  const requestedPath = params.get('source_path') || '';
  const sourcePath =
    requestedPath.startsWith('/') &&
    !requestedPath.startsWith('//') &&
    !/[\\\u0000-\u001f\u007f]/.test(requestedPath)
      ? requestedPath
      : 'Not provided';
  const billingTestMode = params.get('billing_test_mode');
  const billingModeLabel =
    billingTestMode === 'true'
      ? 'TEST mode'
      : billingTestMode === 'false'
        ? 'Not in TEST mode'
        : 'Unavailable';

  return (
    <section>
      <p className="eyebrow">Help</p>
      <h1>Support</h1>
      {hasBugContext ? (
        <form className="support-bug-context" aria-label="Bug report context" onSubmit={(event) => event.preventDefault()}>
          <h2>Bug report context</h2>
          <p>Page and billing-mode details carried from the app:</p>
          <label htmlFor="support-source-path">Current page</label>
          <input id="support-source-path" name="source_path" value={sourcePath} readOnly />
          <label htmlFor="support-billing-mode">Billing mode</label>
          <input id="support-billing-mode" name="billing_test_mode" value={billingModeLabel} readOnly />
          <p role="status">Email these details to support if you need help.</p>
        </form>
      ) : null}
      <div className="notice">
        <h2>Contact support</h2>
        <p>Email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.</p>
      </div>
      <h2>Self-service</h2>
      <div className="card-grid">
        <Link className="nav-card" to="/billing">Billing and receipts</Link>
        <Link className="nav-card" to="/devices/pair">Device pairing</Link>
        <Link className="nav-card" to="/settings">Account settings</Link>
      </div>
    </section>
  );
}
